// extracted by mini-css-extract-plugin
module.exports = {"taskGroupMain":"TaskGroup_taskGroupMain__18pin","header":"TaskGroup_header__27PXJ"};